module.exports = __webpack_public_path__ + "static/media/mario-eyes.afde8e76.svg";